var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkillsHexagon = function SvgSkillsHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 310,
    fill: "none",
    viewBox: "0 0 340 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeWidth: 4,
    d: "m247.206 248.479-105.38-1.978-50.978-92.251 54.403-90.273 105.381 1.978 50.977 92.251z",
    className: "skills-hexagon_svg__empty_hex",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    fillRule: "evenodd",
    stroke: "#F17900",
    d: "m111 0 96.129 55.75v111.5L111 223l-96.129-55.75V55.75z",
    className: "skills-hexagon_svg__orange_hex",
    clipRule: "evenodd"
  })));
};
export default SvgSkillsHexagon;